document.addEventListener('DOMContentLoaded', () => {
  const dailySchedule = () => {
    const element = document.querySelector('.daily-schedule__swiper');
    const swiperInstance = new Swiper(element, {
      slidesPerView: 1.9,
      watchOverflow: true,
      navigation: {
        nextEl: '.press-swiper__next',
        prevEl: '.press-swiper__prev'
      },
      breakpoints: {
        1600: {
          slidesPerView: 9
        },
        1460: {
          slidesPerView: 8
        },
        1280: {
          slidesPerView: 7
        },
        1068: {
          slidesPerView: 6
        },
        992: {
          slidesPerView: 5
        },
        768: {
          slidesPerView: 4.2
        },
        550: {
          slidesPerView: 3.3
        },
        468: {
          slidesPerView: 2.9
        },
        400: {
          slidesPerView: 2.4
        },
      }
    });

    swiperInstance.on('resize', function(instance) { 
      element.classList.toggle('slider--inactive', instance.virtualSize <= instance.size);
    });

  };

  dailySchedule();
});